module.exports = __webpack_public_path__ + "assets/img/swiper-5.83d3637f.jpg";